import { Link, RoutesUrls } from '~shared/lib/router';
import { useTranslation } from '~shared/lib/i18n';
import { Button } from '~shared/ui';

import pageNotFoundImage from '~shared/assets/pageNotFoundImage.png';
import { SiteLayout } from '~pages/layouts/SiteLayout';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <SiteLayout>
      <div className="bg-[#F5F5F5] min-h-[70vh] flex flex-col items-center justify-center py-20">
        <h1 className="text-[32px] font-bold text-black mb-4 sm:text-[24px]">
          {t('site:error404Title')}
        </h1>
        <p className="text-[16px] text-[#7B7C7D] mb-6 sm:text-[14px]">
          {t('site:error404Description')}
        </p>
        <img
          src={pageNotFoundImage}
          alt="404"
          className="max-w-[700px] w-full sm:max-w-[400px] mb-10"
        />
        <Link to={RoutesUrls.main}>
          <Button type="primary" size="large">
            {t('site:main')}
          </Button>
        </Link>
      </div>
    </SiteLayout>
  );
};
